import { useMediaQuery } from 'react-responsive';

export const deviceWidth = {
  desktop: 992,
  tablet: 768,
  mobile: 577,
  tinyScreen: 400,
};

export const Desktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: deviceWidth.desktop });
  return isDesktop ? children : null;
};
export const Tablet = ({ children }) => {
  const isTablet = useMediaQuery({
    minWidth: deviceWidth.tablet,
    maxWidth: deviceWidth.desktop - 1,
  });
  return isTablet ? children : null;
};
export const Mobile = ({ children }) => {
  const isMobile = useMediaQuery({ maxWidth: deviceWidth.mobile });
  return isMobile ? children : null;
};
export const Default = ({ children }) => {
  const isNotMobile = useMediaQuery({ minWidth: deviceWidth.mobile + 1 });
  return isNotMobile ? children : null;
};

export const TinyScreen = ({ children }) => {
  const isTinyScreen = useMediaQuery({ maxWidth: deviceWidth.tinyScreen });
  return isTinyScreen ? children : null;
};
